export const userInfoMutation = `
    mutation UserInfo($inputData: InputUserInfo!) {
        userInfo(inputData: $inputData) {
            isSuccess
        }
    }
`;
